var _circle, _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClear(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 107,
    height: 107,
    viewBox: "0 0 107 107",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 53.5,
    cy: 53.5,
    r: 29.5,
    fill: "#8075FF"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 54,
    y1: 91,
    x2: 54,
    y2: 107,
    stroke: "#8075FF",
    strokeWidth: 6
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 54,
    x2: 54,
    y2: 16,
    stroke: "#8075FF",
    strokeWidth: 6
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 78.9197,
    y1: 79.8545,
    x2: 90.5128,
    y2: 91.4476,
    stroke: "#8075FF",
    strokeWidth: 6
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    y1: -3,
    x2: 16.3952,
    y2: -3,
    transform: "matrix(0.707107 -0.707107 -0.707107 -0.707107 79.3871 27.1254)",
    stroke: "#8075FF",
    strokeWidth: 6
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 25.867,
    y1: 29.2467,
    x2: 14.2738,
    y2: 17.6536,
    stroke: "#8075FF",
    strokeWidth: 6
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    y1: -3,
    x2: 16.3952,
    y2: -3,
    transform: "matrix(-0.707107 0.707107 0.707107 0.707107 27.9883 79.3871)",
    stroke: "#8075FF",
    strokeWidth: 6
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 91,
    y1: 53,
    x2: 107,
    y2: 53,
    stroke: "#8075FF",
    strokeWidth: 6
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    y1: 53,
    x2: 16,
    y2: 53,
    stroke: "#8075FF",
    strokeWidth: 6
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClear);
export default __webpack_public_path__ + "static/media/clear.63d5b0c8ff8c9937e8b3a33a882283d3.svg";
export { ForwardRef as ReactComponent };